export default __webpack_public_path__ + "static/media/degree_next.b55b9c93.png";